'use client'

import React, { Fragment, ReactElement, useContext } from 'react'
import { ReplacerObject } from '../../../../../MyStichtingOpenHelpers/src/static'
import { DictionaryContext } from '../../../providers/dictionary-provider'

export interface DictionaryTextProps {
    textKey: string
    replacer?: ReplacerObject
}

interface Attributes {
    'data-dictionary-key'?: string
}
export const DictionaryText = ({ textKey, replacer }: DictionaryTextProps): ReactElement => {
    const { getText, areKeysVisible } = useContext(DictionaryContext)

    if (!textKey) return <>no umbraco key provided</>

    const Node = areKeysVisible ? 'span' : Fragment
    const attributes: Attributes = areKeysVisible ? { 'data-dictionary-key': textKey } : {}

    return <Node {...attributes}>{getText(textKey, replacer)}</Node>
}
